export default ({ user }) => user.role.type !== 'observer';
